import ConfirmChangesModel from "./model";
import styled from "styled-components";

const ConfirmChanges = styled(ConfirmChangesModel)`
  #root & {
  }
`;

export default ConfirmChanges;
